
import { routingManagement } from '../api'
import notifications from '../notifications'

var _currentData = undefined

function _remapData(originalData) {
  return {
    id: originalData.id,
    internalId: originalData.student.internal_id,
    firstName: originalData.student.first_name,
    lastName: originalData.student.last_name,
    scheduleRequest: `(dbId=${originalData.schedule_request.db_id}), ${originalData.schedule_request.requested_start_date} to ${originalData.schedule_request.requested_end_date}`,
    building: (originalData.schedule_request?.building)
      ? `(dbId=${originalData.schedule_request?.building?.id}), ${originalData.schedule_request?.building?.name}`
      : '---',
  }
}

async function _getData(params) {
  try {
    let response = await routingManagement.getPendingNotification(params)
    _currentData = response.data
    return _currentData
  }
  catch (error) {
    notifications.pushError(`Unable to load Pending Notifications! ${error.response.data.error}`, error)
  }
}

async function _deleteByIds(ids) {
  try {
    let response = await routingManagement.postPendingNotificationDelete({ ids: ids })
    return response.data
  }
  catch (error) {
    notifications.pushError(`Unable to delete selected Pending Notifications! ${error.response.data.error}`, error)
    throw ids
  }
}

export default {
  remapData: _remapData,
  getData: _getData,
  deleteByIds: _deleteByIds,
}
